import { Branding,DisabledPrompt, Link, useModel } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import BID1224ProfilePageContent from "./classes/BID1224ProfilePageContent";
import React from "react";

import "./styles.css";
import BID126ProfilePageContent from "./classes/BID126ProfilePageContent";

/**
 * @function ProfilePage
 * @return {React.Component}
 * @exported true
 * @description The main component for ProfilePage
 */
export default function ProfilePage(props) {
  const { branding } = useModel();
  const { options } = branding;
  const customClientBIDBranding = options.bid_abi22;

  return (
    <PageContainer className="profile-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Profile" />
          { customClientBIDBranding !== "1224" &&
            customClientBIDBranding !== "126" &&
            <ProfilePageContent/>
          }
          { customClientBIDBranding === "1224" &&
            <BID1224ProfilePageContent/>
          }
          { customClientBIDBranding === "126" &&
            <BID126ProfilePageContent />
          }
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}

/**
 * @function ProfilePage
 * @return {React.Component}
 * @exported false
 * @description The default content for the profile page. 
 * Other bids may not use the same content, like the links.
 */
function ProfilePageContent() {
  return (
    <div className="flex-container flex-vertical">
      <Branding id="email_abi22" value="true">
        <div className="flex-height link-item">
          <Link to="/email">Email Address</Link>
        </div>
      </Branding>
      <Branding id="phone_abi22" value="true">
        <div className="flex-height link-item">
          <Link to="/phoneNumber">Phone</Link>
        </div>
      </Branding>
      <Branding id="address_abi22" value="true" default="true">
        <div className="flex-height link-item">
          <DisabledPrompt>
            <Link>Address</Link>
          </DisabledPrompt>
        </div>
      </Branding>           
      <div className="flex-height link-item">
        <Link to="/password">Password</Link>
      </div>
      <Branding id="user_id_abi22" value="true" default="true">
        <div className="flex-height link-item">
          <Link to="/userId">User ID</Link>
        </div>
      </Branding>
      
      <div className="flex-height link-item">
        <Link to="/stoppedNumbers">Stopped Numbers</Link>
      </div>
      <Branding id="tax_documents_abi22" value="true" default="true">
        <div className="flex-height link-item">
          <DisabledPrompt>
            <Link>Tax Documents</Link>
          </DisabledPrompt>
        </div>
      </Branding>
      
      {/* <div className="flex-height link-item">
          <Link to="/actContactInfo">
            Contact Information
          </Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/securityQuestions">Security Questions</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/userActivity">User Activity</Link>
      </div> */}
    </div>
  );
}